import React from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

type HeaderNSidebarProps = {
  cx: string;
};

export const HeaderNSidebar: React.FC<HeaderNSidebarProps> = ({
  children,
  cx,
}) => {
  return (
    <>
      <Sidebar />
      <Header />
      <main className={cx}>{children}</main>
    </>
  );
};
